import { render, staticRenderFns } from "./bindUserDialog.vue?vue&type=template&id=ed35f9a0"
import script from "./bindUserDialog.vue?vue&type=script&lang=js"
export * from "./bindUserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports